import { render, staticRenderFns } from "./FollowResult.vue?vue&type=template&id=897d655c&scoped=true&"
import script from "./FollowResult.vue?vue&type=script&lang=js&"
export * from "./FollowResult.vue?vue&type=script&lang=js&"
import style0 from "./FollowResult.vue?vue&type=style&index=0&id=897d655c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897d655c",
  null
  
)

export default component.exports